// Vue 2 mixin
export default {
    data() {
      return {
        isFullscreen: false,
        fullscreenChangeHandler: null,
        mouseMoveHandler: null,
        isMouseMoving: false,
        isMouseMovingTimeout: null,
      };
    },
    methods: {
      goFullscreen() {
        const el = document.documentElement;
        if (el.requestFullscreen) el.requestFullscreen();
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
        else if (el.msRequestFullscreen) el.msRequestFullscreen();
      },
      exitFullScreen() {
        if (document.fullscreenElement) document.exitFullscreen();
        this.selectDashboardDisplay?.('default');
      },
      listenToKeypressfullscreen(e) {
        if (e.key === 'F11') {
          if (document.fullscreenElement) this.exitFullScreen();
          else document.documentElement.requestFullscreen();
        }
      },
      handleFullscreenChange() {
        this.isFullscreen = !!document.fullscreenElement;
        this.$emit('toggleFullscreen', this.isFullscreen);
        const area = this.$refs.dashboardArea;
        if (area) area.style.zoom = 1;
        if (!this.isFullscreen) this.selectDashboardDisplay?.('default');
        this.zoomLevel = 100;
      },
      hideDashboardDisplayToggleButton() {
        clearTimeout(this.isMouseMovingTimeout);
        this.isMouseMoving = true;
        this.isMouseMovingTimeout = setTimeout(() => {
          this.isMouseMoving = false;
        }, 5000);
      },
    },
    mounted() {
      this.mouseMoveHandler = this.hideDashboardDisplayToggleButton;
      document.addEventListener('mousemove', this.mouseMoveHandler);
      this.fullscreenChangeHandler = this.handleFullscreenChange;
      document.addEventListener('fullscreenchange', this.fullscreenChangeHandler);
      document.addEventListener('keyup', this.listenToKeypressfullscreen);
    },
    beforeDestroy() {
      if (this.mouseMoveHandler) {
        document.removeEventListener('mousemove', this.mouseMoveHandler);
        this.mouseMoveHandler = null;
      }
      if (this.fullscreenChangeHandler) {
        document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
        this.fullscreenChangeHandler = null;
      }
      document.removeEventListener('keyup', this.listenToKeypressfullscreen);
      clearTimeout(this.isMouseMovingTimeout);
    },
  };
  